<template>
  <CRow>
    <CCol col="12" xl="12">
      <transition name="slide">
      <CCard>
        <CCardHeader>
          <h4>Τιμολόγιο</h4> {{ this.client_company }}
        </CCardHeader>
        <CModal
          class="modalAlert"
          :show.sync="alertIsShown"
          :centered="true"
          size="lg"
        >
          <CAlert
            closeButton
            :show.sync="alertIsShown"
            color="primary"
            fade
          >
            {{ message }}
          </CAlert>
        </CModal>
        <CCardBody>
          <CTabs>
              <CTab title="Στοιχεία Τιμολογίου" active>
                <CCard>
                  <CCardBody>
                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Τύπος παραστατικού</label>

                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="document_series" 
                          id="document_series" 
                          :options="document_series_options"
                          label="label"
                          track-by="value"
                          :disabled='disabledField'>
                        </multiselect>
                      </CCol>
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Σειρά παραστατικού</label>

                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="document_series_seira" 
                          id="document_series_seira" 
                          :options="document_series_seira_options"
                          @input="selectedDocSer($event)"
                          label="label"
                          track-by="value"
                          :disabled='disabledField'>
                        </multiselect>
                      </CCol>

                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Αριθμός Παραστατικού</label>
                        <CInput type="text" id="document_number" class="customInputHeight" placeholder="Αριθμός Παραστατικού" v-model="document_number" :disabled='disabledField'></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row form-group mb-3">
                      <CCol xl="12" lg="12">
                        <label class="requiredLabel">Πελάτης</label>
                        <CRow>
                          <CCol>
                            <multiselect 
                              :select-label="'Select'"
                              :deselect-label="'Remove'"
                              v-model="client" 
                              id="client" 
                              :options="clients_options"
                              label="label"
                              @input="selectedClient($event)"
                              @remove="removeSelectedClient"
                              track-by="value"
                              :disabled='disabledField'>
                            </multiselect>
                          </CCol>
                          <CCol lg="auto" v-if="client">
                            <CButton 
                              @click="$router.push({path: '/clients/' + client.value + '/edit'})" 
                              color="primary"
                              class="mb-2 customBtnHeight"
                              v-if="!isMarked"
                            >
                              Επεξεργασία Πελάτη
                            </CButton>
                          </CCol>
                        </CRow>
                      </CCol>
                    </CRow>
                      
                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΑΦΜ Πελάτη</label>
                        <CInput type="text" id="client_afm" placeholder="ΑΦΜ Πελάτη" v-model="client_afm" :disabled='isMarked'></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">ΔΟΥ Πελάτη</label>
                        <CInput type="text" id="client_doy" placeholder="ΔΟΥ Πελάτη" v-model="client_doy" :disabled='isMarked'></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Υπεύθυνος Επικοινωνίας
                        <CInput type="text" id="client_name" placeholder="Υπεύθυνος Επικοινωνίας" v-model="client_name" :disabled='isMarked'></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (1):	
                        <CInput type="text" id="client_phone" placeholder="Τηλέφωνο" v-model="client_phone" :disabled='isMarked'></CInput>
                      </CCol>

                      <CCol xl="4" lg="12">
                        Τηλ. Επικοινωνίας (2):	
                        <CInput type="text" id="client_phone_2" placeholder="Τηλέφωνο" v-model="client_phone_2" :disabled='isMarked'></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Διεύθυνση Πελάτη</label>
                        <CInput type="text" id="client_address" placeholder="Διεύθυνση Πελάτη" v-model="client_address" :disabled='isMarked'></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Πόλη</label>
                        <CInput type="text" id="client_town" placeholder="Πόλη" v-model="client_town" :disabled='isMarked'></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel mb-0">Νομός</label>
                        <CInput type="text" id="client_state" placeholder="Νομός" v-model="client_state" :disabled='isMarked'></CInput>
                      </CCol>
                      
                      <CCol xl="4" lg="12">
                        Ταχυδρομικός Κώδικας
                        <CInput type="text" id="client_postcode" placeholder="Ταχυδρομικός Κώδικας" v-model="client_postcode" :disabled='isMarked'></CInput>
                      </CCol>
                    </CRow>
                    

                    <CRow class="form-row form-group">
                      <CCol xl="4" lg="12">
                        <label class="requiredLabel">Ημερομηνία</label>

                        <CInput
                          type="date"
                          id="date"
                          v-model="date"
                          :disabled='isMarked'
                        />
                      </CCol>
                    </CRow>

                    <div v-if="!isMarked">
                      <CButton 
                        :disabled="!(!!client || !!invoice_client)"
                        @click="collapse = !collapse" 
                        color="primary"
                        class="mb-2"
                      >
                        Υπηρεσίες
                      </CButton>
                      <CCollapse :show="collapse">
                        <CCard body-wrapper>
                          <CRow>
                            <CCol xl="6" lg="12">
                              Υποθέσεις
                              <multiselect 
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="services" 
                                id="services" 
                                :options="servicesOptions"
                                label="label"
                                @input="selectedIsoCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!invoice_services || !!invoice_client || !client"
                                track-by="value">
                              </multiselect>
                            </CCol>

                            <CCol xl="6" lg="12">
                              Υπηρεσίες Τιμολογίου
                              <multiselect 
                                :select-label="'Select'"
                                :deselect-label="'Remove'"
                                v-model="invoice_services" 
                                id="invoice_services" 
                                :options="invoice_servicesOptions"
                                @input="selectedCases($event)"
                                @remove="removeSelectedCases"
                                :disabled="!!services || !(!!client || !!invoice_client)"
                                label="label"
                                track-by="value">
                              </multiselect>
                            </CCol>
                          </CRow>

                          <CRow class="mt-3">
                            <CCol xl="4" lg="12">
                              Ποσότητα
                              <CInput type="number" min="1" id="quantity" placeholder="Ποσότητα" v-model="quantity" @input="check_if_negative_quantity($event)"></CInput>
                            </CCol>

                            <CCol xl="4" lg="12">
                              Τιμή χωρίς ΦΠΑ (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="price_without_vat" placeholder="Τιμή" v-model="price_without_vat" @input="calculate_final_price($event)"></CInput>
                            </CCol>
                            
                            <CCol xl="4" lg="12">
                              Συνολική Αξία (τεμάχιο, σε €)
                              <CInput type="text" inputmode="decimal" id="total_price" placeholder="Συνολική Αξία" v-model="total_price" @input="calculate_price_without_vat($event)"></CInput>
                            </CCol>
                          </CRow>

                          <CRow>
                            <CCol xl="8" lg="12">
                              Σχόλια
                              <CTextarea
                                rows="1"
                                v-model="notes"
                                class="textareaHeight"
                              />
                            </CCol>
                          </CRow>

                          <CCol sm="12" class="mt-2 pl-0" v-show="showAdd && showAddVat">
                            <CButton color="primary" @click="addRow()">Προσθήκη</CButton>
                          </CCol>
                        </CCard>
                      </CCollapse>
                    </div>
                    <br>

                      <CDataTable
                        :items="serviceLoopToDatatable"
                        :fields="fields"
                        :items-per-page="10"
                        pagination
                        hover
                        :loading="loading"
                        sorter
                        class="invoicesTable"
                      >
                      <template #services="{item}">
                        <td>
                          <span v-if="item.services">
                            {{item.notes}}
                          </span>
                          <span v-if="item.invoice_services">
                            {{item.notes}}
                          </span>
                        </td>
                      </template>
                      <template #quantity="{item}">
                        <td>
                          <span v-if="item.quantity">
                            {{ item.quantity }}
                          </span>
                        </td>
                      </template>
                      <template #price_without_vat="{item}">
                        <td>
                          <span v-if="item.price_without_vat">
                            {{ item.price_without_vat }}€
                          </span>
                        </td>
                      </template>
                      <template #total_price="{item}">
                        <td>
                          <span v-if="item.total_price">
                            {{ item.total_price }}€
                          </span>
                        </td>
                      </template>
                      <template #delete="{item}">
                        <td>
                          <span v-if="you!=item.id && !isMarked" @click="deleteRow(item.id)" class="minusBtn"><CIcon :content="cilMinusBtn" color="danger" :height="20" /></span>
                        </td>
                      </template>
                    </CDataTable>

                    <CButton v-if="serviceLoopToDatatable.length != 0" color="primary" class="float-right" @click="updateInvoice()">Αποθήκευση</CButton>


                  </CCardBody>
                </CCard>
              </CTab>
              
              <CTab title="Ρυθμίσεις">
                <CCard>
                  <CCardBody>
                    <div class="form-row form-group">
                      <CCol sm="3">
                        Καθεστώς ΦΠΑ
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :disabled='isMarked'
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="vat_price" 
                          id="vat_price" 
                          :options="vat_prices_options"
                          label="label"
                          track-by="value">
                        </multiselect>
                      </CCol>
                    </div>

                    <div class="form-row form-group">
                      <CCol sm="3">
                        Γλώσσα
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="invoice_lang" 
                          id="invoice_lang" 
                          :options="invoice_lang_options"
                          @input="selectedInvoiceLanguage($event)"
                          label="label"
                          track-by="value"
                          :disabled='disabledField'>
                        </multiselect>
                      </CCol>
                    </div>                    
                  </CCardBody>
                </CCard>
              </CTab>

              <CTab v-if="showMyDataTab"  title="My Data">
                <CCard>
                  <CCardBody>
                    <CModal
                      class="modalAlert"
                      :show.sync="alertIsShownMYDATA"
                      :centered="true"
                      size="lg"
                    >
                      <CAlert
                        closeButton
                        :show.sync="alertIsShownMYDATA"
                        color="primary"
                        fade
                      >
                        {{ messageMYDATA }}
                      </CAlert>
                    </CModal>


                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="6">
                        <label>Κατάσταση</label>
                        <CInput type="text" class="customInputHeight" v-model="invoiceStatus" :disabled='disabledField'></CInput>
                      </CCol>                  
                    </CRow>

                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="12">
                        <label>UID</label>
                        <CInput type="text" id="uid" class="customInputHeight" v-model="uid" :disabled='disabledField'></CInput>
                      </CCol>
                      <CCol xl="4" lg="12">
                        <label>ΜΑΡΚ</label>
                        <CInput type="text" id="mark" class="customInputHeight" v-model="mark" :disabled='disabledField'></CInput>
                      </CCol>                      
                      <CCol xl="4" lg="12">
                        <label>ΜΑΡΚ ακύρωσης</label>
                        <CInput type="text" id="cancelled_mark" class="customInputHeight" v-model="cancelled_mark" :disabled='disabledField'></CInput>
                      </CCol>
                    </CRow>

                    <CRow class="form-row form-group mb-0">
                      <CCol xl="4" lg="12">
                        <label>Ημερομηνία Δημιουργίας</label>
                        <CInput
                          type="text"
                          id="date"
                          v-model="date"
                          :disabled='disabledField'
                        />
                      </CCol>   
                      <CCol xl="4" lg="12">
                        <label>Ημερομηνία Διαβίβασης</label>
                        <CInput type="text" id="date_mark_created" class="customInputHeight" v-model="date_mark_created" :disabled='disabledField'></CInput>
                      </CCol>                                         
                    </CRow>

                    <CButton v-if="serviceLoopToDatatable.length != 0 && !isMarked" color="primary" class="float-right" @click="sendToMyData()">Αποθήκευση και Αποστολή στο My Data</CButton>
                    <CButton v-if="serviceLoopToDatatable.length != 0 && isMarked && !isCancelled" color="primary" class="float-right" @click="sentCancellationToMydata()">Ακύρωση Τιμολογίου</CButton>

                  </CCardBody>
                </CCard>
              </CTab>

              <CTab title="Πληρωμές">
                <CCard>
                  <CCardBody>
                    <div class="form-row form-group">
                      <CCol sm="3">
                        Κατάσταση πληρωμής
                      </CCol>
                      <CCol sm="9">
                        <multiselect 
                          :select-label="'Select'"
                          :deselect-label="'Remove'"
                          v-model="payment_status" 
                          id="payment_status" 
                          label="label"
                          track-by="value"
                          @input="changePaidAmount()"
                          :options="payment_options">
                        </multiselect>
                      </CCol>
                    </div>

                    <div class="form-row form-group" v-show="payment_status && payment_status.value != 0">
                      <CCol sm="3">
                        Ποσό πληρωμής
                      </CCol>
                      <CCol sm="9">
                        <CInput type="number" class="customInputHeight" v-model="paid_amount"></CInput>
                      </CCol>
                       <CCol sm="12"> <p>Υπόλοιπο: {{ remainingPrice }}€</p></CCol>
                      <CCol sm="3">
                        Σχόλιο
                      </CCol>
                      <CCol sm="9">
                        <CInput type="text" class="customInputHeight" v-model="payment_comment"></CInput>
                        <!-- <textarea  rows="3" width="100%">
                        </textarea> -->
                      </CCol>
                    </div>
                      <div
                      class="form-row form-group"
                      v-if="payment_status && payment_status.value === 0"
                    >
                      <CCol sm="3">
                        Σχόλιο
                      </CCol>
                      <CCol sm="9">
                        <CInput
                          type="text"
                          class="customInputHeight"
                          v-model="payment_comment"
                        ></CInput>
                      </CCol>
                    </div>
                    <CButton v-if="serviceLoopToDatatable.length != 0" color="primary" class="float-right" @click="updateInvoice()">Αποθήκευση</CButton>
                  </CCardBody>
                </CCard>
              </CTab>        
          </CTabs>
        </CCardBody>
      </CCard>
      </transition>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios'
import { DatePicker } from 'v-calendar'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import Multiselect from 'vue-multiselect'
import moment from 'moment'
import { cilMinus } from '@coreui/icons'
import LoginVue from '../pages/Login.vue'

const fieldsEN = [
  {
    key: 'id', 
    label: 'No.', 
    sorter: false, 
    filter: false
  },
  {
    key: 'services', 
    label: 'Services', 
    sorter: false, 
    filter: false
  },
  // {
  //   key: 'notes', 
  //   label: 'Services Description', 
  //   sorter: false, 
  //   filter: false
  // },
  {
    key: 'quantity', 
    label: 'Quantity', 
    sorter: false, 
    filter: false
  },
  {
    key: 'price_without_vat', 
    label: 'Unit Price', 
    sorter: false, 
    filter: false
  },
  {
    key: 'total_price', 
    label: 'Amount', 
    sorter: false, 
    filter: false
  },
  {
    key: 'delete', 
    label: '', 
    sorter: false, 
    filter: false
  }
];

const fieldsEL = [
  {
    key: 'id', 
    label: 'Α/Α', 
    sorter: false, 
    filter: false
  },
  {
    key: 'services', 
    label: 'Υπηρεσίες', 
    sorter: false, 
    filter: false
  },
  // {
  //   key: 'notes', 
  //   label: 'Περιγραφή', 
  //   sorter: false, 
  //   filter: false
  // },
  {
    key: 'quantity', 
    label: 'Ποσότητα', 
    sorter: false, 
    filter: false
  },
  {
    key: 'price_without_vat', 
    label: 'Τιμή χωρίς ΦΠΑ', 
    sorter: false, 
    filter: false
  },
  {
    key: 'total_price', 
    label: 'Συνολική Αξία', 
    sorter: false, 
    filter: false
  },
  {
    key: 'delete', 
    label: '', 
    sorter: false, 
    filter: false
  }
];

const fields = [];

export default {
  name: 'EditInvoice',
  components: {
    'v-date-picker': DatePicker,
    Multiselect,
  },
  data: () => {
    return {
      items: [],
      fields,
      fieldsEN,
      fieldsEL,
      invoice_ID: '',
      document_series: '',
      document_series_options: [],
      document_series_seira: '',
      document_series_seira_options: [],
      client: '',
      clients_options: [],
      invoice_client: '',
      invoice_clients_options: [],
      date: '',
      document_number: '',
      document_number_temp: '',
      invoice_services: '',
      servicesOptions: [],
      services: '',
      invoice_servicesOptions: [],
      client_afm: '',
      client_doy: '',
      client_address: '',
      client_company: '',
      client_phone: '',
      client_phone_2: '',
      client_town: '',
      client_state: '',
      client_id_invoice: '',
      client_postcode: '',
      client_name: '',
      typeClient: '',
      quantity: '',
      price_without_vat: '',
      total_price: '',
      invoice_services_raw: '',
      clients_raw: '',
      services_raw: '',
      invoice_clients_raw: '',
      document_series_raw: '',
      document_series_seira_raw: '',
      notes: '',
      vat_price: '',
      vat_prices_options: [],
      invoice_lang: '',
      invoice_lang_options: [{ label: 'Ελληνικά', value: 'greek' }, { label: 'Αγγλικά', value: 'english' }],
      collapse: true,
      disabledField: true,
      showAdd: false,
      showAddVat: false,
      serviceLoopToDatatable: [],
      cilMinusBtn: cilMinus,
      currentPage: 1,
      perPage: 5,
      totalRows: 0,
      you: null,
      message: '',
      loading: true,
      showMessage: false,
      alertIsShown: false,
      dismissSecs: 7,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      mark: '',
      cancelled_mark: '',
      uid: '',
      alertIsShownMYDATA: false,
      messageMYDATA: '',
      showMessageMYDATA: false,
      date_mark_created: '',
      payment_status: 0,
      paid_amount: 0,
      payment_options: [],
      payment_comment: ''
    }
  },
  paginationProps: {
    align: 'center',
    doubleArrows: false,
    previousButtonHtml: 'prev',
    nextButtonHtml: 'next'
  },
  computed: {

    showMyDataTab(){      
      if(this.document_series_options !== null && this.document_series_options !== undefined && this.document_series_options.length !== 0){
        var canceledInvoicesList = this.document_series_options.filter(opt => opt.label.includes('Ακυρωτικό')).map(item => item['value'])

        if(canceledInvoicesList.includes(this.document_series.value)){
          return false
        }
      }

      return true
    },

    alertModal: {
      get() {
        return this.dismissCountDown > 0;
      },
      set() {
        this.dismissCountDown = 0;
      }
    },

    isMarked(){
      return (this.mark !== '') && (this.mark !== null);
    },

    invoiceStatus(){
      return this.isMarked ? 'Διαβιβασμένο' : 'Εκκρεμές';
    },

    isCancelled(){
      return (this.cancelled_mark !== '') && (this.cancelled_mark !== null);
    },

    totalPrice() {
      if (this.serviceLoopToDatatable && this.serviceLoopToDatatable.length) {
        return parseFloat(this.serviceLoopToDatatable.reduce(function(a, b) { return a + parseFloat(b.total_price);}, 0));
      }
      return 0;
    },
    remainingPrice() {
      return (this.totalPrice - this.paid_amount).toFixed(2);
    }
  },
  watch: {
    alertIsShown: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    },
    alertIsShownMYDATA: function(newVal, oldVal) {
      if (! newVal && this.saved) {
        this.$emit('closed-alert');
      }
    }
  },
  methods: {
    changePaidAmount() {
      if (this.payment_status.value == 2) {
        this.paid_amount = this.totalPrice;
      } else if (this.payment_status.value == 0) {
        this.paid_amount = 0;
      }
    },
    addRow () {
      let self = this; 

      var id = 1;
      if (this.serviceLoopToDatatable.length) {
        id = Math.max.apply(Math,this.serviceLoopToDatatable.map(function(o){return o.id;})) + 1;
      }

      if (self.services && self.invoice_lang.value == 'greek') {
        self.notesTmp = 'ΠΙΣΤΟΠΟΙΗΣΗ '+self.printServiceName(self.services.label)+' (Αρ. Υπόθ. '+self.services.label+') '+self.notes;
      } else if (self.services && self.invoice_lang.value == 'english') {
        self.notesTmp = self.printServiceName(self.services.label)+' Certification for (Αρ. Υπόθ. '+self.services.label+') '+self.notes;
      } else if (self.invoice_services) {
        self.notesTmp = self.invoice_services.label +' '+ self.notes;
      }

      if (self.services) {
        this.serviceLoopToDatatable.push({ id , services: self.services.label, invoice_services: null, notes: self.notesTmp, quantity: self.quantity, price_without_vat: (self.price_without_vat*self.quantity).toFixed(2), total_price: (self.total_price*self.quantity).toFixed(2), serviceID: null });
      } else if (self.invoice_services) {
        this.serviceLoopToDatatable.push({ id , services: null, invoice_services: self.invoice_services.label, notes: self.notesTmp, quantity: self.quantity, price_without_vat: (self.price_without_vat*self.quantity).toFixed(2), total_price: (self.total_price*self.quantity).toFixed(2), serviceID: null });
      }
      self.services = null;
      self.invoice_services = null;
      self.notes = '';
      self.quantity = 1;
      self.price_without_vat = '';
      self.total_price = '';

      this.showAdd = false;
      this.showAddVat = false;
    },
    printServiceName(service_label) {
      let self = this;

      var tempClient = self.clients_raw.find((item) => { if (item.id == self.client.value) { return item; } });

      var tempCaseID = tempClient.cases.find((item) => { if (item.case_code == service_label) { return item; } });

      var tempServiceName = self.services_raw.find((item) => { if (item.id == tempCaseID.service_id) { return item; } });

      return tempServiceName.name;
    },
    deleteRow(id) {
      this.serviceLoopToDatatable = this.serviceLoopToDatatable.filter((item) => item.id != id);
    },
    removeSelectedCases () {
      let self = this; 

      if (self.showAdd == true) {
        self.showAdd = false;
      }
    },
    selectedIsoCases (selected) {
      let self = this; 

      if (selected) {
        if (self.showAdd == false) {
          self.showAdd = true;
        }

        // pass the price on price_without_vat
        var tempClient = self.clients_raw.find((item) => { if (item.id == self.client.value) { return item; } });
        var tempServiceID = tempClient.cases.find((item) => { if (item.id == selected.value) { return item; } });
        var tempService = tempClient.services.find((item) => { if (item.id == tempServiceID.service_id) { return item; } });

        if (tempService) {
          self.calculate_final_price(tempService.pivot.price_service);

          return self.price_without_vat = tempService.pivot.price_service;
        }
      }
    },
    selectedCases (selected) {
      let self = this; 

      if (selected) {
        if (self.showAdd == false) {
          self.showAdd = true;
        }
      }
    },
    removeSelectedClient () {
      let self = this;

      if (self.showAdd == true) {
        self.showAdd = false;
      }

      if (self.collapse == true) {
        self.collapse = false;
      }

      self.client_address = '';
      self.client_company = '';
      self.client_phone = '';
      self.client_phone_2 = '';
      self.client_town = '';
      self.client_state = '';
      self.client_postcode = '';
      self.client_afm = '';
      self.client_doy = '';
      self.client_name = '';
      self.notes = '';
      self.quantity = 1;
      self.price_without_vat = '';
      self.total_price = '';

      if (self.services) {
        self.services = null;
      }

      if (self.invoice_services) {
        self.invoice_services = null;
      }
    },
    selectedDocSer(val) {
      if (val) {
        this.document_number = ('00000' + val.invoice_count).slice(-5);
      }
    },
    selectedClient (val) {
      let self = this;

      if (val) {
        if (self.services) {
          self.services = null;
          self.notes = '';
          self.quantity = 1;
          self.price_without_vat = '';
          self.total_price = '';
        }

        if (self.invoice_services) {
          self.invoice_services = null;
          self.notes = '';
          self.quantity = 1;
          self.price_without_vat = '';
          self.total_price = '';
        }

        var temp = self.clients_raw.find((item) => { if (item.id == val.value) { return item; } });
      
        self.client_address = temp.address;
        self.client_company = temp.company;
        self.client_phone = temp.phone_number_1;
        self.client_phone_2 = temp.phone_number_2;
        self.client_town = temp.town;
        self.client_state = temp.state;
        self.client_postcode = temp.postcode;
        self.client_afm = temp.afm;
        self.client_doy = temp.doy;
        self.client_name = temp.contact_name;
        self.servicesOptions = temp.cases.map((item) => {
          return {
            label: item.case_code,
            value: item.id
          }
        })
      }
    },
    selectedInvoiceClient (val) {
      let self = this;

      if (val) {
        var temp = self.invoice_clients_raw.find((item) => { if (item.id == val.value) { return item; } });
      
        self.client_address = temp.address;
        self.client_company = temp.company;
        self.client_phone = temp.phone_number_1;
        self.client_phone_2 = temp.phone_number_2;
        self.client_town = temp.town;
        self.client_state = temp.state;
        self.client_postcode = temp.postcode;
        self.client_afm = temp.afm;
        self.client_doy = temp.doy;
        self.client_name = temp.name;
        self.notes = '';
        self.quantity = 1;
        self.price_without_vat = '';
        self.total_price = '';
      }
    },
    check_if_negative_quantity(quantity) {
      let self = this;

      if (quantity) {
        if (quantity <= 0) {
          return self.quantity = 1;
        } else if (quantity >= 1) {
          return quantity;
        }
      }
    },
    calculate_final_price (price_without_vat) {
      let self = this;

      if (price_without_vat) {
        // Accept both comma and dot as decimal separator
        if (typeof price_without_vat === 'string') {
          price_without_vat = price_without_vat.replace(',', '.');
          self.price_without_vat = price_without_vat;
        }
        let price_no_vat = parseFloat(price_without_vat);
        let fpa_percentage = this.vat_price.value;
        let price_with_vat = parseFloat(price_no_vat * fpa_percentage);
        let final_price_calculated = price_no_vat + price_with_vat;

        this.showAddVat = true;

        return self.total_price = final_price_calculated.toFixed(2);
      } else {
        this.showAddVat = false;

        return self.total_price = '';
      }
    },
    calculate_price_without_vat (total_price) {
      let self = this;

      if (total_price) {
        // Accept both comma and dot as decimal separator
        if (typeof total_price === 'string') {
          total_price = total_price.replace(',', '.');
          self.total_price = total_price;
        }
        let fpa_percentage = this.vat_price.value;
        let price_with_vat = parseFloat(1 + fpa_percentage);
        let final_price_without_vat_calculated = parseFloat(total_price) / price_with_vat;

        this.showAddVat = true;

        return self.price_without_vat = final_price_without_vat_calculated.toFixed(2);
      } else {
        this.showAddVat = false;

        return self.price_without_vat = '';
      }
    },
    selectedInvoiceLanguage (lang) {
      let self = this;

      if (lang.value == 'english') {
        self.vat_price = self.vat_prices_options.find((i) => i.value == 0);

        self.document_series_options = self.document_series_raw.map((item) => {
          return {
            value: item.id,
            label: item.english_name,
          }
        });

        self.document_series = self.document_series_options.find((item) => item.label == "Invoice of Rendered Services");

        self.document_series_seira_options = self.document_series_seira_raw.filter((item) => item.lang == 'en');

        self.document_series_seira_options = self.document_series_seira_options.map((item) => {
          return {
            value: item.id,
            invoice_count: item.invoice_count + 1,
            lang: item.lang,
            label: item.name,
          }
        });
        self.document_series_seira = self.document_series_seira_options[0];

        self.document_number = self.document_series_seira.label + self.document_series_seira.invoice_count;

        self.fields = self.fieldsEN;

      } else if (lang.value == 'greek') {
        self.vat_price = self.vat_prices_options.find((i) => i.value == 0.24);

        self.document_series_options = self.document_series_raw.map((item) => {
          return {
            value: item.id,
            label: item.greek_name,
          }
        });

        self.document_series = self.document_series_options.find((item) => item.label == "Τιμολόγιο Παροχής Υπηρεσιών");
        
        self.document_series_seira_options = self.document_series_seira_raw.filter((item) => item.lang == 'gr');

        self.document_series_seira_options = self.document_series_seira_options.map((item) => {
          return {
            value: item.id,
            invoice_count: item.invoice_count + 1,
            lang: item.lang,
            label: item.name,
          }
        });
        self.document_series_seira = self.document_series_seira_options[0];

        self.document_number = self.document_series_seira.label + self.document_series_seira.invoice_count;

        self.fields = self.fieldsEL;
      }
    },
    getServiceID(service_name) {
      let self = this;

      if (self.client.label) {
        var tempClient = self.clients_raw.find((item) => { if (item.id == self.client.value) { return item; } });

        var tempServiceName = tempClient.cases.find((item) => { if (item.case_code == service_name) { return item; } });
        
        return tempServiceName.id;
      }
    },
    getInvoiceServiceID(invoice_service_name) {
      let self = this;

      if (self.client.label) {
        var tempInvoiceServiceName = self.invoice_services_raw.find((item) => { if (item.name == invoice_service_name) { return item; } });

        return tempInvoiceServiceName.id;
      } else if (self.invoice_client.label) {
        var tempInvoiceServiceName = self.invoice_services_raw.find((item) => { if (item.name == invoice_service_name) { return item; } });
        
        return tempInvoiceServiceName.id;
      }
    },

    sendToMyData(){
        let self = this;

        let serviceLoopToDatatable = self.serviceLoopToDatatable.filter((item) => item.services && item.quantity && item.price_without_vat && item.total_price);
        serviceLoopToDatatable = self.serviceLoopToDatatable.map((item) => { 

          let service, type;
          if (item.services) {
            service = self.getServiceID(item.services);
            type = 'case';
          }

          if (item.invoice_services) {
            service = self.getInvoiceServiceID(item.invoice_services);
            type = 'service';
          }
            return {
                serviceID: item.serviceID,
                service: service,
                type: type,
                service_description: item.notes,
                service_quantity: item.quantity,
                price_without_vat: item.price_without_vat,
                total_price: item.total_price
            }
        });

        let client_id, client_type;
        if (self.client) {
          client_id = self.client.value;
          client_type = 'client';
        }

        if (self.invoice_client) {
          client_id = self.invoice_client.value;
          client_type = 'invoice_client';
        }

        let document_series_id = null;
        if (this.document_series) {
          document_series_id = this.document_series.value;
        }

        let document_series_seira_id = null;
        if (this.document_series_seira) {
          document_series_seira_id = this.document_series_seira.value;
        }

        let payment_status = null;
        if (this.payment_status) {
          payment_status = this.payment_status.value
        }

        axios.post('/api/invoices/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            invoice_language: self.invoice_lang.value,
            document_number: self.document_number,
            document_series_id: document_series_id,
            document_series_seira_id: document_series_seira_id,
            invoice_date: self.date,
            client_name: self.client_name,
            client_afm: self.client_afm,
            client_doy: self.client_doy,
            client_address: self.client_address,
            client_company: self.client_company,
            client_phone: self.client_phone,
            client_phone_2: self.client_phone_2,
            client_town: self.client_town,
            client_state: self.client_state,
            client_postcode: self.client_postcode,
            services: serviceLoopToDatatable,
            client_id: client_id,
            client_type: client_type,
            fpa_percentage: self.vat_price.value,
            paid_amount: self.paid_amount,
            payment_status: payment_status,
            payment_comment: self.payment_comment
        })
        .then(function (response) {
            
            axios.get('/api/invoices/createMark/'+ self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
              .then(function(res){

                console.log(res.data)

                  if(res.data.status === 'SUCCESS'){
                    self.messageMYDATA = 'Επιτυχής απόστολή & απόκτηση MARK';
                    self.mark = res.data.invoice['mark'];
                    self.uid = res.data.invoice['uid'];
                    self.date_mark_created = res.data.invoice['date_mark_created'];
                  }else if(res.data.status === null){
                    alert('status null');
                  }
                  else{
                    self.messageMYDATA = res.data.message;
                  }

                  self.showAlertMYDATA();
                
              }).catch(function(e){
                  alert('Error');
                  console.log(e.response.data.message);

                  if(error.response.data.message == 'The given data was invalid.'){
                    self.messageMYDATA = '';
                      for (let key in error.response.data.errors) {
                        if (error.response.data.errors.hasOwnProperty(key)) {
                          self.messageMYDATA += error.response.data.errors[key][0] + '  ';
                        }
                      }
                      self.showAlertMYDATA();
                  }else{
                    self.$router.push({ path: '/login' }); 
                  }
              });



        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
             self.messageMYDATA = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.messageMYDATA += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlertMYDATA();
            }else{
              self.$router.push({ path: '/login' }); 
            }
        });
    },

    sentCancellationToMydata(){
        let self = this;
        
        // self.serviceLoopToDatatable[0].total_price = self.serviceLoopToDatatable[0].total_price * -1;      
        
        axios.get('/api/invoices/cancelMark/'+ self.$route.params.id + '?token=' + localStorage.getItem("api_token"))
          .then(function(res){
              self.messageMYDATA = res.data.message;
              self.showAlertMYDATA();
              if(res.data.status !== 'ERROR'){
                self.cancelled_mark = res.data.cancelledMark;

                self.serviceLoopToDatatable.forEach(row => row.total_price = row.total_price * -1);
              }
          }).catch(function(e){
              if(error.response.data.message == 'The given data was invalid.'){
                self.messageMYDATA = '';
                  for (let key in error.response.data.errors) {
                    if (error.response.data.errors.hasOwnProperty(key)) {
                      self.messageMYDATA += error.response.data.errors[key][0] + '  ';
                    }
                  }
                  self.showAlertMYDATA();
              }else{
                self.$router.push({ path: '/login' }); 
              }
          });
    },

    updateInvoice() {
        let self = this;

        let serviceLoopToDatatable = self.serviceLoopToDatatable.filter((item) => item.services && item.quantity && item.price_without_vat && item.total_price);
        serviceLoopToDatatable = self.serviceLoopToDatatable.map((item) => {

          let service, type;
          if (item.services) {
            service = self.getServiceID(item.services);
            type = 'case';
          }

          if (item.invoice_services) {
            service = self.getInvoiceServiceID(item.invoice_services);
            type = 'service';
          }
            return {
                serviceID: item.serviceID,
                service: service,
                type: type,
                service_description: item.notes,
                service_quantity: item.quantity,
                price_without_vat: item.price_without_vat,
                total_price: item.total_price
            }
        });

        let client_id, client_type;
        if (self.client) {
          client_id = self.client.value;
          client_type = 'client';
        }

        if (self.invoice_client) {
          client_id = self.invoice_client.value;
          client_type = 'invoice_client';
        }

        let document_series_id = null;
        if (this.document_series) {
          document_series_id = this.document_series.value;
        }

        let document_series_seira_id = null;
        if (this.document_series_seira) {
          document_series_seira_id = this.document_series_seira.value;
        }

        let payment_status = null;
        if (this.payment_status) {
          payment_status = this.payment_status.value
        }

        axios.post('/api/invoices/' + self.$route.params.id + '?token=' + localStorage.getItem("api_token"),
        {
            _method: 'PUT',
            invoice_language: self.invoice_lang.value,
            document_number: self.document_number,
            document_series_id: document_series_id,
            document_series_seira_id: document_series_seira_id,
            invoice_date: self.date,
            client_name: self.client_name,
            client_afm: self.client_afm,
            client_doy: self.client_doy,
            client_address: self.client_address,
            client_company: self.client_company,
            client_phone: self.client_phone,
            client_phone_2: self.client_phone_2,
            client_town: self.client_town,
            client_state: self.client_state,
            client_postcode: self.client_postcode,
            services: serviceLoopToDatatable,
            client_id: client_id,
            client_type: client_type,
            fpa_percentage: self.vat_price.value,
            paid_amount: self.paid_amount,
            payment_status: payment_status,
            payment_comment: self.payment_comment
        })
        .then(function (response) {
            self.message = 'Επιτυχής επεξεργασία τιμολογίου.';
            self.showAlert();
        }).catch(function (error) {
            if(error.response.data.message == 'The given data was invalid.'){
              self.message = '';
              for (let key in error.response.data.errors) {
                if (error.response.data.errors.hasOwnProperty(key)) {
                  self.message += error.response.data.errors[key][0] + '  ';
                }
              }
              self.showAlert();
            }else{
              self.$router.push({ path: '/login' }); 
            }
        });
    },
    InvoiceLink (id) {
      return `invoice/${id.toString()}`
    },
    showInvoice ( id ) {
      this.$router.replace({path: `/invoices/${id.toString()}`});
    },
    countDownChanged (dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert () {
      this.alertIsShown = true
    },
    showAlertMYDATA(){
      this.alertIsShownMYDATA = true
    },
    getInvoice () {
      let self = this;
      axios.get('/api/invoices/' + self.$route.params.id + '/edit?token=' + localStorage.getItem("api_token"))
      .then(function (response) {
        var momentObj = moment(response.data.invoice.invoice_date, 'DD-MM-YYYY');
        self.date = momentObj.format('YYYY-MM-DD');
        self.document_number = response.data.invoice.document_number;
        self.client_afm = response.data.invoice.client_afm;
        self.client_doy = response.data.invoice.client_doy;
        self.client_address = response.data.invoice.client_address;
        self.client_company = response.data.invoice.client_company;
        self.client_id_invoice = response.data.invoice.client_id;
        self.client_state = response.data.invoice.client_state;
        self.client_town = response.data.invoice.client_town;
        self.client_postcode = response.data.invoice.client_postcode;
        self.client_phone = response.data.invoice.client_phone;
        self.client_phone_2 = response.data.invoice.client_phone_2;
        self.client_name = response.data.invoice.client_name;
        self.typeClient = response.data.invoice.client_type;

        self.mark = response.data.invoice.mark;
        self.cancelled_mark = response.data.invoice.cancelledMark;
        self.uid = response.data.invoice.uid;
        self.date_mark_created = response.data.invoice.date_mark_created;

        self.invoice_services_raw = response.data.invoice_services;
        self.services_raw = response.data.services;
        self.clients_raw = response.data.clients;
        self.invoice_clients_raw = response.data.invoice_clients;
        self.document_series_raw = response.data.document_series;
        self.document_series_seira_raw = response.data.document_series_seira;

        self.payment_options = response.data.payment_options.map((item, index) => {
          return {
            value: index,
            label: item
          }
        });
        self.payment_status = self.payment_options.find((item) => item.value == response.data.invoice.payment_status);
        self.payment_comment = response.data.invoice.payment_comment;
        self.paid_amount = response.data.invoice.paid_amount;

        if (response.data.invoice.length) {
          self.invoice_ID = Math.max.apply(Math,response.data.invoice.map(function(o){return o.id;})) + 1
        } else {
          self.invoice_ID = 1;
        }

        self.vat_prices_options = response.data.vat_prices.map((item) => {
          return {
            value: item.percentage,
            label: item.vat,
          }
        });
        self.vat_price = self.vat_prices_options.find((item) => item.value == response.data.invoice.fpa_percentage);

        if (response.data.invoice.invoice_language == 'greek') {
          self.document_series_options = response.data.document_series.map((item) => {
            return {
              value: item.id,
              label: item.greek_name,
            }
          });
          self.document_series = self.document_series_options.find((item) => item.value == response.data.invoice.document_series_id);
          
          self.document_series_seira_options = response.data.document_series_seira.map((item) => {
            return {
              value: item.id,
              invoice_count: item.invoice_count + 1,
              lang: item.lang,
              label: item.name,
            }
          });
          self.document_series_seira = self.document_series_seira_options.find((item) => item.value == response.data.invoice.document_series_seira_id);

          self.fields = self.fieldsEL;
        } else if (response.data.invoice.invoice_language == 'english') {
            self.document_series_options = response.data.document_series.map((item) => {
              return {
                value: item.id,
                label: item.english_name,
              }
            });
            self.document_series = self.document_series_options.find((item) => item.value == response.data.invoice.document_series_id);
            
            self.document_series_seira_options = response.data.document_series_seira.map((item) => {
              return {
                value: item.id,
                invoice_count: item.invoice_count + 1,
                lang: item.lang,
                label: item.name,
              }
            });
            self.document_series_seira = self.document_series_seira_options.find((item) => item.value == response.data.invoice.document_series_seira_id);

            self.fields = self.fieldsEN;
        }

        self.clients_options = response.data.clients.map((item) => {
          return {
            value: item.id,
            label: item.company,
            cases: item.cases
          }
        });

        self.invoice_clients_options = response.data.invoice_clients.map((item) => {
          return {
            value: item.id,
            label: item.company,
          }
        });

        if (self.typeClient.includes('InvoiceClients')) {
          // user is invoice client
          self.invoice_client = self.invoice_clients_options.find((item) => item.label == self.client_company);
        } else {
          // user is client
          self.client = self.clients_options.find((item) => item.value == self.client_id_invoice);
        
          var ID_client = self.client.value;
          var temp = self.clients_raw.find((item) => { if (item.id == ID_client) { return item; } });
          self.servicesOptions = temp.cases.map((item) => {
            return {
              label: item.case_code,
              value: item.id
            }
          });
        }

        self.invoice_servicesOptions = response.data.invoice_services.map((item) => {
          return {
            label: item.name,
            value: item.id,
          }
        });

        self.quantity = 1;

        self.invoice_lang = self.invoice_lang_options.find((i) => i.value == response.data.invoice.invoice_language);

        let idCounter = 1;
        response.data.invoice.invoices_cases.map((item) => {
          return self.serviceLoopToDatatable.push({ id: idCounter++, services: item.service.case_code, invoice_services: item.service.name, notes: item.service_description, quantity: item.service_quantity, price_without_vat: item.price_without_vat, total_price: item.total_price, serviceID: item.id });
        });

        self.loading = false;
      }).catch(function (error) {
        console.log(error);
        self.loading = false;
        self.$router.push({ path: '/login' });
      });
    },
    showAlert () {
      this.alertIsShown = true
    },
  },
  mounted: function() {
    this.getInvoice();
  }
}
</script>
